var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layoutContent"},[_c('div',{staticClass:"contentParty contentPartyWap"},[_c('Nav',{ref:"nav",attrs:{"tab-index":_vm.tabIndex},scopedSlots:_vm._u([{key:"basic-info",fn:function(){return [_c('BasicInfo')]},proxy:true},{key:"change-password",fn:function(){return [_c('ChangePassword')]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }